import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, resolveComponent as _resolveComponent, unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "h-screen w-screen flex flex-col bg-disconnected" }
const _hoisted_2 = { class: "flex-grow flex justify-center items-center" }
const _hoisted_3 = { class: "py-15 flex flex-col text-center" }
const _hoisted_4 = { class: "text-2xl text-light4 font-black uppercase truncate" }
const _hoisted_5 = { class: "text-72 leading-tight font-black" }
const _hoisted_6 = { class: "text-xl" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "h-20 bg-dark" }, null, -1)

import TopBar from "@/components/TopBar.vue";
import router from "@/router";
import homePath from "@/router/paths";
import loggingService from "@/services/LoggingService";
import { useProfileStore } from "@/store/Profile";
import { storeToRefs } from "pinia";
import { onMounted, watch } from "vue";


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const { connected } = storeToRefs(useProfileStore());
const profileStore = useProfileStore();

onMounted(() => {
  loggingService.info("Disconnected.vue", "📴 Displaying disconnected view");
});

watch(connected, () => {
  loggingService.debug("ProfileStore.ts", `🛣️ Changing route to ${homePath}`);
  router.push(homePath);
});

return (_ctx: any,_cache: any) => {
  const _component_FontAwesomeIcon = _resolveComponent("FontAwesomeIcon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(TopBar, { "is-connected": "" }),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_FontAwesomeIcon, {
          icon: ['fa-light', 'triangle-exclamation'],
          size: "8x",
          class: "text-light2 mb-8"
        }),
        _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.$t("resourceName", { resourceName: _unref(profileStore).resourceName })), 1),
        _createElementVNode("h1", _hoisted_5, _toDisplayString(_ctx.$t("noInternet")), 1),
        _createElementVNode("h3", _hoisted_6, _toDisplayString(_ctx.$t("forRealTime")), 1)
      ])
    ]),
    _hoisted_7
  ]))
}
}

})